var _circle, _circle2, _circle3, _circle4, _circle5, _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 110,
    fill: "#FFFFFF",
    opacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 96,
    fill: "#FFFFFF",
    opacity: 0.14
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 82,
    fill: "#FFFFFF",
    opacity: 0.24
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 70,
    fill: "#FFFFFF",
    opacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 62,
    fill: "#FFFFFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 88,
    width: 52,
    height: 9,
    rx: 4.5,
    fill: "#E77FA0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 143,
    width: 52,
    height: 9,
    rx: 4.5,
    fill: "#E77FA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99,97 L141,97 L120,120 Z",
    fill: "#F4A62A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120,120 L99,152 L141,152 Z",
    fill: "#F4A62A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeout);
export default __webpack_public_path__ + "static/media/timeout.18f7fb4f8a8007636a0c193a1129a4c3.svg";
export { ForwardRef as ReactComponent };